export default {
  "greeting_zero": "Olá, {{ user }}! Como você está?",
  "greeting_one": "{{ user }}, comece a estudar agora.",
  "greeting_other": "{{ user }}, comece a estudar agora.",
  "mycourses_empty": "Você ainda não se inscreveu em nenhum curso. Quando você adquirir um curso ele aparecerá aqui.",
  "suggestion": "Sugestão nossa para você, o que acha?"
}
